export const EmptyGuid = '00000000-0000-0000-0000-000000000000';

export function idIsBlank(id: string | undefined | null): boolean {
  return id === undefined || id === null || id === EmptyGuid;
}